import React from "react";
import { injectIntl } from "react-intl";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";
import Button from "@app/components/CustomButtons/Button";
import Card from "@app/components/Card/Card";
import CardAvatar from "@app/components/Card/CardAvatar";

import authorSionnach from "@app/assets/img/logos/sionnach-solutions-logo-square-red.png";
import authorLocalPro from "@app/assets/img/logos/local-pro-logo-red.png";
import authorFograi from "@app/assets/img/logos/fograi-260w.png";

import sectionBlogAuthorStyle from "@app/assets/jss/material-kit-pro-react/views/blogPostSections/sectionBlogInfoStyle";

function SectionBlogAuthor({ ...props }) {
  const { classes } = props;

  const connectViaLinkedIn = props.intl.formatMessage({ id: "connect.via.linkedin" });
  const connectViaTwitter = props.intl.formatMessage({ id: "connect.via.twitter" });
  const theAuthor = props.intl.formatMessage({ id: "blog.written.by" });
  const sionanchLinkedIn = "https://www.linkedin.com/company/sionnach-solutions/";
  const sionnachName = "sionnach-solutions";
  const localProTwitter = "https://twitter.com/LocalProIE";
  const localProName = "@LocalProIE";
  const fograiTwitter = "https://twitter.com/fograi_ie";
  const fograiName = "@fograi_ie";

  const authorImg = props.author==='sionnach' ? authorSionnach : (props.author==='localpro' ? authorLocalPro : authorFograi);
  const socialName = props.author==='sionnach' ? sionnachName : (props.author==='localpro' ? localProName : fograiName);

  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <hr />
          <Card plain profile className={classes.card}>
            <GridContainer>
              <GridItem xs={12} sm={3} md={3}>
                <CardAvatar plain profile>
                  <img src={authorImg} />
                </CardAvatar>
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <h4 className={classes.cardTitle}>
                  {theAuthor}
                </h4>
                <p className={classes.description}>
                  {socialName}
                </p>
              </GridItem>
              <GridItem xs={12} sm={3} md={3}>
              {props.author==='sionnach' && 
                <Button 
                  href={sionanchLinkedIn}
                  color="linkedin">
                  <i className="fab fa-linkedin" /> {connectViaLinkedIn}
                </Button>
              }
              {props.author==='localpro' && 
                <Button 
                  href={localProTwitter}
                  color="twitter">
                  <i className="fab fa-twitter" /> {connectViaTwitter}
                </Button>
              }
              {props.author==='fograi' && 
                <Button 
                  href={fograiTwitter}
                  color="twitter">
                  <i className="fab fa-twitter" /> {fograiTwitter}
                </Button>
              }
              </GridItem>
            </GridContainer>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default injectIntl(withStyles(sectionBlogAuthorStyle)(SectionBlogAuthor));
